import type { AsyncThunkApiConfig } from '@/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { RejectError } from '../../typings'

type Force = boolean | undefined

export const fetchApiKey = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  Force,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/account/fetchApiKey', async (force, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/account/fetchApiKey', {
      type: 'rpc/account/fetchApiKey',
      category: 'rpc',
      force,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        error: result,
        message: result.errorMessage,
      })
    }
  } catch (error) {
    return thunkApi.rejectWithValue({
      error,
      type: 'unknown',
      message: 'Failed to fetch the Account API Key',
    })
  }
})
